<template>
  <div class="set" style="background-color:#fff;position: relative;min-height:100vh;">
    <van-nav-bar
      title="本金及收益保障合同"
      v-if="token.length <= 0"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>
    <div v-if="token.length <= 0" style="height: 29px;"></div>
    <div
      ref="htstr"
      class="content"
      v-html="html"
      style="padding: 20px;padding-top: 60px;padding-bottom:1rem;"
    ></div>
    <!-- <div style="height: 1rem;"></div> -->
  </div>
</template>

<script>
import request from "@utils/request";
export default {
  //   name: "",
  data() {
    return {
      token: "",
      html: "",
      user: {}
    };
  },
  created() {
    console.log("token");
    console.log(this.$route.query.token);
    if (this.$route.query.token) {
      this.token = this.$route.query.token;
      this.$store.commit("Token", this.token);
    }

    this.contract();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    async contract() {
      let id = this.$route.query.id;
      request
        .get("/fund/hetong/index", { id: id }, { login: false })
        .then(res => {
          console.log("-> res.data", res.data);
          this.user = res.data.user;
          const content = this.normalizeContractCurrency(res.data.data || "");
          this.html =
            '<meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no">' +
            content;
          // this.html = res.data.data;
          this.ref(content);
        })
        .catch(err => {
          // this.$dialog.message("请先进行实名认证");
        });
    },
    normalizeContractCurrency(content) {
      return String(content)
        .replace(/应收本息\s*[\(（] USD[\)）]/g, "应收本息(USD)")
        .replace(/投入本金\s*[\(（] USD[\)）]/g, "投入本金(USD)")
        .replace(/收益金额\s*[\(（] USD[\)）]/g, "收益金额(USD)")
        .replace(/已获收益\s*[\(（] USD[\)）]/g, "已获收益(USD)");
    },
    hideContractImage(key) {
      this.$set(this.user, key, "");
    },
    ref: function(res) {
      let _self = this;
      _self.$nextTick(function() {
        this.html.replace(/<script.*?>([\s\S]+?)<\/script>/gim, function(
          _,
          js
        ) {
          let regJs = js;

          var ele = document.createElement("script");
          ele.innerHTML = regJs;
          _self.$refs.htstr.append(ele);
        });
      });
    }
  },
  components: {}
};
</script>
<style scoped lang="less">
.set,
.content {
  background: #fff;
}

.teamindeximg {
  width: 100%;
}

.teamtitle {
  background-color: #f1f5f8;
  font-size: 15px;
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  align-items: center;
  width: calc(100% - 12px);
}

.teamnum {
  background-color: #067594;
  color: #fff;
  padding: 0 8px;
  border-radius: 20px;
  margin-left: 3px;
  font-size: 13px;
  height: 18px;
  line-height: 20px;
}

.teamli {
  border-bottom: 1px solid #f6f6f6;
  padding: 7px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  font-size: 15px;
}

.teamlist {
  padding-right: 12px;
}

.teamlil {
  display: flex;
  align-items: center;
}

.teamlil img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 100%;
  margin-right: 20px;
}
/deep/ .van-nav-bar .van-icon {
  color: #333;
}

/deep/ #all {
  width: 780px;
  padding: 100px 32px;
  background: #fff;
}
</style>

